import DuoColorBorder from "@/components/buttons/custom-border/duo-color-border";
import Image from "next/image";

const ItemAwards = ({ awards }: { awards: any[] }) => (
	<div className={"w-full relative py-[64px]"}>
		<h2 className="text-white font-bold my-[28px] text-right text-[32px] w-full">
			جوایز
		</h2>
		<div className="w-full grid grid-cols-[repeat(auto-fit,minmax(300px,1fr))] gap-4 auto-rows-auto place-items-center md:place-items-start">
			{awards?.length > 0 &&
				awards?.map((achievement: any, index: number) => (
					<DuoColorBorder
						key={index}
						id={`achievement-${index}`}
						color="#B6E9FF"
						secondColor="rgba(0,0,0,0)"
						extraClasses="w-[300px] h-[86px] rounded-[8px]"
						direction="to right"
						borderRadius={"8px"}
					>
						<div
							className={"flex items-center justify-start h-full rounded-md"}
							style={{
								backgroundImage:
									"linear-gradient(to right, transparent 40%, rgba(182,233,255,.2))",
							}}
						>
							{achievement?.logo?.code && (
								<div className="relative w-[76px] h-max flex justify-center items-center">
									<img
										src={
											process.env.NEXT_PUBLIC_FILE_URL + achievement?.logo?.code
										}
										alt={achievement?.title}
										className="pb-7 max-w-[76px]"
									/>
									<div className="triangle-down absolute left-auto bottom-[7px]"></div>
									<Image
										className="absolute left-auto bottom-[-6px]"
										src={"/circle.svg"}
										alt={achievement?.title}
										width={97}
										height={67}
									/>
								</div>
							)}
							<p className="font-medium text-[18px] mr-6">
								{achievement?.persianTitle}
							</p>
						</div>
					</DuoColorBorder>
				))}
		</div>
	</div>
);

export default ItemAwards;
